var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElRow',{staticClass:"footer",attrs:{"type":"flex","justify":"center"}},[_c('ul',_vm._l((_vm.availableLocales),function(item,index){return _c('li',{key:index},[_c('a',{on:{"click":function($event){return _vm.changeLanguage(item.code)}}},[_vm._v(_vm._s(_vm.$t(item.label)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }